/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description All possible types of Freewheel parameters
 */
export enum FreewheelParameterType {
	GLOBAL = 'Global',
	SITE = 'Site',
	CUSTOM = 'Custom',
}